export const requestIdleCallbackPolyfill = (callback: () => void) => {
  setTimeout(callback, 0)
}
